import classNames from 'classnames';
import Card from 'src/components/Card/Card';
import { Card as CardType } from 'src/types/Card';

import styles from './doctors-cards.module.scss';

type DoctorsCardsProps = {
    cards: CardType[];
    className?: string;
};

const DoctorsCards = (props: DoctorsCardsProps) => {
    return (
        <div
            className={classNames(
                'w-full overflow-x-auto mb-8',
                props.cards && props.cards.length === 1 ? 'md:mb-0' : 'lg:mb-0',
                props.className
            )}
        >
            <div
                className={classNames(
                    'flex space-x-4 snap-mandatory snap-x scroll-pr-8',
                    props.cards.length > 1 && 'pb-4',
                    styles['wrapper'],
                    props.cards.length === 1 && 'justify-center lg:justify-end',
                )}
                data-cards-count={props.cards.length}
            >
                {props.cards.map((item, index) => (
                    <div
                        key={index}
                        className={classNames(
                            "px-[2px] pb-[2px]",
                            props.cards.length === 1 ? styles['card-single'] : "w-[80%] shrink-0 sm:w-[48%] lg:w-1/2",
                            props.cards.length === 2 && 'lg:w-[48%]'
                        )}
                    >
                        <Card
                            image={item.image}
                            name={item.name}
                            className={classNames(
                                styles['doctor-card'],
                                item.className,
                                'mb-1'
                            )}
                            subtitle={item.subtitle}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DoctorsCards;
